import { get } from 'jquery'
import React, { useState, useEffect } from 'react'

const OnlineStatusChecker = () => {
  const [isOnline, setIsOnline] = useState(true) // Default: Server dianggap online
  const [serverStatus, setServerStatus] = useState(true) // Default: Server dianggap online
  const baseurl = process.env.REACT_APP_BACKEND_URL

  useEffect(() => {
    const handleOnlineStatusChange = () => {
      setIsOnline(navigator.onLine)
    }

    const checkServerStatus = async () => {
      try {
        const response = await get(`${baseurl}branch-umum`) // Ganti dengan URL server Anda
        
        if (response.code !== 200) {
          setServerStatus(false) // Server tidak aktif
        } else {
          setServerStatus(true) // Server tidak aktif
        }
      } catch (error) {
        setServerStatus(false) // Server tidak aktif
      }
    }

    window.addEventListener('online', handleOnlineStatusChange)
    window.addEventListener('offline', handleOnlineStatusChange)

    checkServerStatus() // Mengecek status server saat komponen dipasang

    // Setiap 10 detik, cek ulang status server
    const interval = setInterval(checkServerStatus, 10000)

    return () => {
      window.removeEventListener('online', handleOnlineStatusChange)
      window.removeEventListener('offline', handleOnlineStatusChange)
      clearInterval(interval) // Membersihkan interval saat komponen dilepas
    }
  }, [])

  return (
    <>
      {isOnline ? (
        <>
          <span style={{ color: serverStatus ? 'green' : 'red', fontSize: '15px' }}>● </span>
          {serverStatus ? 'Server dan Anda online' : 'Server tidak aktif atau tidak dapat diakses'}
        </>
      ) : (
        <>
          <span style={{ color: 'red', fontSize: '15px' }}>● </span>
          Anda sedang offline. Periksa koneksi internet Anda
        </>
      )}
    </>
  )
}

export default OnlineStatusChecker
